





































import Vue, { PropType } from 'vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { IChartOptions } from '@/types/dashboard';
import { DropdownList } from '@/types';
import i18n from '@/i18n';

export default Vue.extend({
  name: 'ChartWidget',
  components: { FieldSelect, Preloader },

  props: {
    periods: {
      type: Array,
      required: true,
      default: () => [],
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectOptions: {
      type: Array as PropType<Array<DropdownList>>,
      required: true,
      default: () => [],
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mounted() {
    this.changeSelect();
  },

  watch: {
    currentSelect() {
      this.changeSelect();
    },
  },

  computed: {
    currentSelectedOption(): DropdownList {
      return (
        this.selectOptions.find((s) => s.value === this.currentSelect) ||
        this.selectOptions[0]
      );
    },
    chartOptions(): IChartOptions {
      return {
        chart: {
          type: 'areaspline',
          backgroundColor: '#FFFFFF',
        },
        title: {
          text: this.currentSelectedOption.label,
          align: 'left',
          style: { color: '#6A7280', fontWeight: 'bold' },
        },
        subtitle: {
          text: i18n.t('pages.dashboard.byDay'),
          align: 'left',
          style: { color: '#BFC4D9' },
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: 'left',
          itemMarginBottom: 6,
        },
        rangeSelector: {
          enabled: false,
        },
        noData: {
          style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030',
          },
        },
        tooltip: {
          split: true,
        },
        xAxis: {
          categories: this.periods,
        },
        yAxis: {
          opposite: false,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              radius: 3,
            },
            fillOpacity: 0.2,
          },
        },
        series: this.data,
      };
    },
  },

  methods: {
    changeSelect() {
      this.$emit('changeSelect', this.currentSelect);
    },
  },

  data() {
    return {
      currentSelect: this.selectOptions[0].value,
    };
  },
});
